import http from "src/services/http";
import queryString from "query-string";
import * as types from "src/store/types/clientes";

export const carregarClientes = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/clientes?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.EMP_CLIENTES_SET_LISTA, payload: data },
          { type: types.EMP_CLIENTES_SET_PAGE, payload: page },
          { type: types.EMP_CLIENTES_SET_TOTAL, payload: total },
          { type: types.EMP_CLIENTES_SET_PERPAGE, payload: per_page },
          { type: types.EMP_CLIENTES_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.EMP_CLIENTES_LOADING, payload: false }]);
      }
    );
  };
};

export const bloquearCliente = (cliente_id) => {
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/empresa/clientes/bloquear/${cliente_id}`).then(
      () => resolve(),
      (e) => reject(e)
    );
  });
};

export const desbloquearCliente = (cliente_id) => {
  return new Promise((resolve, reject) => {
    http.delete(`/api/v2/empresa/clientes/desbloquear/${cliente_id}`).then(
      () => resolve(),
      (e) => reject(e)
    );
  });
};

export const carregarClienteExtrato = (cliente_id) => {
  // const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/clientes/${cliente_id}/extratos`).then(
      (resp) => {
        dispatch([
          { type: types.EMP_CLIENTES_SET_EXTRATO, payload: resp.data },
          { type: types.EMP_CLIENTES_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.EMP_CLIENTES_LOADING, payload: false }]);
      }
    );
  };
};
